import { AboutUs } from '../components/AboutUs';
import { Services } from '../components/Services';
import { News } from '../components/News';
import { Contact } from '../components/Contact';
import { Hero } from '../components/Hero';

export function Home() {
    return (
        <div className="min-h-screen">
            {/* Hero Section */}
            <Hero />

            {/* About Us Section */}
            <AboutUs />

            {/* Services Section */}
            <Services />

            {/* News Section */}
            <News />

            {/* Contact Section */}
            <Contact />
        </div>
    );
}
